import { Button } from '@mui/material';
import BonusCard from '../DealerBonus/BonusCard';
import LoaderComp from '../../components/LoaderComp';
import dayjs from 'dayjs';
import { Popconfirm } from 'antd';
import { BorderColorOutlined } from '@mui/icons-material';
import CustomPopOver from './CustomPopOver';
import { InterestRateContext } from '.';
import { useContext } from 'react';
import RadioInput from '../../components/Form/RadioInput';

const ViewInterest = (props) => {
  const { itemIdx } = props;
  const { productData, isFetching, pagePermissions } =
    useContext(InterestRateContext);
  let product = productData.interests[itemIdx]?.agentbonusinfo;
  if (props.schedule) {
    product = productData.interests[itemIdx]?.agentbonusinfo.schedule;
  }
  return (
    <>
      {!isFetching ? (
        <div className='p-[24px_30px_24px_30px] singleLoanTab'>
          <div className='flex flex-wrap items-center mt-[10px] gap-[0px_10px] cus_date_pick mb-[15px]'>
            <label className='flex flex-wrap items-center w-full mb-[15px] font-[700] text-[13px] text-[#27272B]'>
              Publish Date
              <CustomPopOver For='publish' />
            </label>
            <div className='flex items-center'>
              <div className='text-[13px]'>
                {dayjs(product?.startDate).format('DD-MM-YYYY')}
              </div>
              <span className='mx-[10px] text-[13px]'>To</span>
              <div className='text-[13px]'>
                {product?.endDate
                  ? dayjs(product?.endDate).format('DD-MM-YYYY')
                  : 'Further Notice'}
              </div>
            </div>
          </div>
          {props.schedule && (
            <div className='mb-[27px]'>
              <label className='flex flex-wrap items-center w-full mb-[15px] text-[13px] text-[#27272B] font-[700]'>
                Schedule Date
                <CustomPopOver For='schedule' />
              </label>
              <div className='text-[13px]'>
                {dayjs(product?.scheduleDate).format('DD-MM-YYYY HH:mm')}
              </div>
            </div>
          )}

          <div className='voucher-quantity-block mb-4'>
            <label className='flex flex-wrap items-center w-full mb-[15px] font-[700] text-[13px] text-[#27272B]'>
              Loan Commission Type
            </label>
            <div className='voucher-quantity-list'>
              <RadioInput
                name='options'
                value='1'
                label='Pro-rate Commission'
                className='!mb-0'
                checked={product?.commision_type === 1}
                disabled={true}
              /> 
                <RadioInput
                  name='options'
                  value='2'
                  label='Full Commission'
                  className='!mb-0'
                  checked={product?.commision_type === 2}
                  disabled={true}
                /> 
            </div>
          </div>
          <div className='mb-[27px]'>
            <label className='text-[#27272B] font-[700] text-[13px]'>
              Dealer Commission Rates
            </label>
            <div className='flex mt-[16px] gap-[8px] relative'>
              <div className='stick_header w-[115px] flex-shrink-0'>
                <p className='text-[13px] text-[#495159] mb-[17px]'>
                  Tenor (Years)
                </p>
                <p className='text-[13px] text-[#495159] mb-[20px]'>
                  Availability
                </p>
                <p className='text-[13px] text-[#495159] flex items-center'>
                  Commission
                </p>
              </div>
              <div className='flex scBarHidden w-[950px] overflow-x-scroll gap-[25px]'>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((it) => {
                  return (
                    <div className='text-center dealer_com w-[95px]' key={it}>
                      <p className='text-[#495159] mb-[12px] text-[13px]'>
                        {it}
                      </p>
                      <Popconfirm
                        title='Want to edit this?'
                        okText='Edit'
                        cancelText='Cancel'
                        icon={
                          <BorderColorOutlined
                            className='mr-[10px]'
                            fontSize={'small'}
                            htmlColor='#59758a'
                          />
                        }
                        onConfirm={() => {
                          props.editHandle();
                        }}
                        disabled={pagePermissions?.update_permission === 0}
                      >
                        <div
                          className={`custom_switch cursor-pointer ${
                            !product[`year${it}_status`] && 'disable'
                          }`}
                        >
                          <span className='sw_text'>AVL</span>
                          <span className='thumb'></span>
                        </div>
                      </Popconfirm>
                      <p className='mt-[15px] text-[#263238] text-[13px]'>
                        {product[`year${it}_status`]
                          ? product[`year${it}_fee`]
                          : 'NA'}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className='mb-[27px]'>
            <label className='text-[#27272B] font-[700] text-[13px] mb-[14px] block'>
              Admin Fee
            </label>
            {product.adminfees.map((item, idx) => {
              return (
                <div className='mb-[25px]' key={idx}>
                  <p className='text-[#495159] text-[13px] mb-[10px]'>
                    Fee amount {idx + 1}
                    <span className='text-[#263238] ml-[25px] font-[500]'>
                      $ {item.admin_fee}
                    </span>
                  </p>
                  <p className='text-[#495159] text-[13px]'>
                    Loan Amount
                    <span className='text-[#263238] ml-[25px] mr-[10px] font-[500]'>
                      $ {item.minimum_loan_amount}
                    </span>
                    to
                    <span className='ml-[10px] font-[500]'>
                      $ {item.maximum_loan_amount}
                    </span>
                  </p>
                </div>
              );
            })}
          </div>
          {/* {product.has_incentive ? (
            <div className='mb-[27px]'>
              <label className='text-[#27272B] font-[700] text-[13px] mb-[14px] block'>
                Incentive
              </label>
              <div>
                <span className='text-[#263238] text-[14px] font-[500]'>
                  {product.incentive_type === 1 ? '' : '$'}{' '}
                  {product.incentive_amount}
                  {product.incentive_type === 1 ? '%' : ''}
                </span>
              </div>
            </div>
          ) : null} */}
          <div className='mb-[27px]'>
            <label className='text-[#27272B] font-[700] text-[13px] mb-[10px] block'>
              Remarks
            </label>
            <p className='text-[#787486] text-[13px] mb-[7px]'>
              {product.remarks1}
            </p>
            <p className='text-[#787486] text-[13px]'>{product.remarks2}</p>
          </div>
          {/* {product?.agentbonuses.length > 0 && (
            <div className='mb-[27px]'>
              <label className='text-[#27272B] font-[700] text-[13px] mb-[14px] block'>
                Dealer Bonus
              </label>
              <div className='flex flex-wrap gap-[20px_12px]'>
                {product?.agentbonuses &&
                  product?.agentbonuses.map((item, idx) => {
                    return <BonusCard key={idx} bonus={item.bonusinfo} />;
                  })}
              </div>
            </div>
          )} */}
          {pagePermissions?.update_permission === 1 && (
            <Button
              type='button'
              className='sav_btn view_int'
              onClick={() => props.editHandle()}
            >
              Edit
            </Button>
          )}
        </div>
      ) : (
        <LoaderComp />
      )}
    </>
  );
};

export default ViewInterest;
